import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import MoRoleBinding from '@src/ui-components/mo-backpack/role-binding';
import RoleBindingModalStore from './store';

export const RoleBindingModal = ({ onClose, store }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  // 静态壳会以 React 事件调用 handlers。真正的 useModal
  // 关闭回调保留在 store.onClose 上，由 BaseModalStore 消费
  const handleCloseClick = () => store.requestClose();

  return (
    <ModalContainer modalState={store.isOpen}>
      <MoRoleBinding
        step={store.step}
        servers={store.serverPickerOptions}
        roles={store.rolePickerOptions}
        selectedServerId={store.selectedServerId}
        selectedRoleId={store.selectedRoleId}
        loadingServers={store.loadingServers}
        loadingRoles={store.loadingRoles}
        submitting={store.submitting}
        confirmViewModel={store.confirmViewModel}
        onServerChange={store.selectServer}
        onRoleChange={store.selectRole}
        onNext={store.goToConfirm}
        onBack={store.backToSelection}
        onConfirm={store.confirmBinding}
        onClose={handleCloseClick}
      />
    </ModalContainer>
  );
};

export default wrapStore(RoleBindingModal, RoleBindingModalStore);
